import { useMemo } from "react";
import { CreateCardRequest } from "tng-address-collection-shared/types/apiTypes.ts";
import { useUserUidNumber } from "../auth/useUserUidNumber.ts";
import { fallbackCard } from "../defaults/fallbackCard.tsx";
import { initialSenderId } from "../defaults/initialSenderId.ts";
import { useGetProjects } from "./useGetProjects.ts";

export const useGetCreateCardExampleData = (projectId: string) => {
  const uidNumber = useUserUidNumber();
  const { data: projects } = useGetProjects();
  const projectDefaultSenderId = projects?.find(
    ({ id }) => id === projectId,
  )?.defaultSenderId;

  return useMemo(
    (): CreateCardRequest => ({
      ...fallbackCard,
      projectId,
      senderId: initialSenderId(projectDefaultSenderId, uidNumber),
    }),
    [projectId, projectDefaultSenderId, uidNumber],
  );
};
